import { FC } from "react";

import CardTabImage from "./CardTabImage";
import CardTabText from "./CardTabText";
import CardTabTextImage from "./CardTabTextImage";
import { AmenityColumn, ColumnType, ImageAmenityColumn, ImageTextAmenityColumn, TextAmenityColumn } from "./type";

interface ChooseCardGalleryProp {
  column: AmenityColumn;
}

const ChooseCardGallery: FC<ChooseCardGalleryProp> = ({ column }) => {
  return (
    <>
      {column.type == ColumnType.TEXTIMAGE && <CardTabTextImage column={column as ImageTextAmenityColumn} />}
      {column.type === ColumnType.IMAGE && <CardTabImage column={column as ImageAmenityColumn} />}
      {column.type === ColumnType.TEXT && <CardTabText column={column as TextAmenityColumn} />}
    </>
  );
};
export default ChooseCardGallery;
